import { useQuery } from '@shared/modules/use-query/hooks'
import { useCallback, useMemo } from 'react'
import { AppointmentsService } from '../services'
import { AppointmentProduct } from '../types'

export const useAppointmentProducts = (id: string | number) => {
  return useQuery<AppointmentProduct[]>(
    useCallback(async () => {
      const result = await AppointmentsService.getVisitProducts(id)

      if (result.status === 200) {
        return result.data
      } else {
        return []
      }
    }, [id]),
    useMemo(() => ({ initialData: [], enabled: !!id }), [id]),
  )
}
